import { useState } from "react";
import { day } from "./AdsWindows";

const TokenDate = ({ token, owner, onTokenDate }) => {
  const [edit, setEdit] = useState(false);
  const [value, setValue] = useState(token?.set_on || "");
  if (!token) return null;
  if (!token.set_on) return <span data-testid="ads-token" className="text-amber-700">Token date unknown: {token.note}</span>;
  const rot = token.rotation;
  return (
    <span data-testid="ads-token" className="inline-flex flex-wrap items-center gap-1">
      Token set on <b className="text-foreground">{day(token.set_on, { month: "short", day: "numeric", year: "numeric" })}</b> ({token.note})
      {rot?.due ? (
        <b data-testid="ads-token-rotation" className="text-amber-700"> · rotation due since {day(rot.due_since)}</b>
      ) : (
        <span data-testid="ads-token-rotation"> · yearly reminder {day(rot.next_on, { month: "short", day: "numeric", year: "numeric" })}</span>
      )}
      {owner && !edit && (
        <button type="button" data-testid="ads-token-correct" onClick={() => setEdit(true)} className="ml-1 rounded-full border border-border px-2 py-0 text-[10.5px] font-semibold hover:bg-muted">Correct</button>
      )}
      {owner && edit && (
        <span className="inline-flex items-center gap-1">
          <input data-testid="ads-token-date-input" type="date" value={value} onChange={(e) => setValue(e.target.value)}
            className="h-6 rounded-md border border-input bg-background px-1 text-[11px]" />
          <button type="button" data-testid="ads-token-date-save" disabled={!value || value === token.set_on}
            onClick={async () => { await onTokenDate(value); setEdit(false); }}
            className="h-6 rounded-md bg-foreground px-2 text-[10.5px] font-semibold text-background disabled:opacity-40">Save</button>
        </span>
      )}
    </span>
  );
};

const SCOPE = { ads_read_only: "Permissions: ads_read only", no_ads_read: "Permissions: ads_read is missing" };

// Account, attribution, token, permissions, version and how the hours line up, under the figures.
export const AdsFacts = ({ d, owner, onTokenDate }) => {
  const a = d.account;
  const attr = d.attribution;
  return (
    <div className="mt-1.5 shrink-0 space-y-0.5 border-t border-border/60 pt-1.5 text-[11px] leading-tight text-muted-foreground">
      <p className="flex flex-wrap gap-x-3 gap-y-0.5">
        <span data-testid="ads-account"><b className="text-foreground">{a.name || "Ad account"}</b> · …{a.id_last4} · {a.currency} · {a.timezone_name} ({a.utc_offset})
          {a.status && a.status !== "active" ? <b className="text-amber-700"> · account {a.status}</b> : null}</span>
        {attr?.label && (
          <span data-testid="ads-attribution" title={attr.per_campaign.map((c) => `${c.name}: ${c.attribution}`).join("\n")}>
            Attribution: {attr.label === "mixed" ? `mixed (${attr.per_campaign.map((c) => c.attribution).join(" / ")})` : attr.label}
          </span>
        )}
        <span data-testid="ads-scope" className={d.scope?.status === "unchecked" ? "text-amber-700" : ""}>
          {SCOPE[d.scope?.status] || d.scope?.note || ""}
        </span>
        <span data-testid="ads-version" className={d.version_warning ? "font-semibold text-amber-700" : ""}>
          Marketing API {d.version.pinned} pinned{d.version_warning ? " · Meta upgraded a call: bump the pinned version" : ""}
        </span>
      </p>
      <p><TokenDate token={d.token} owner={owner} onTokenDate={onTokenDate} /></p>
      {d.time_note && <p data-testid="ads-time-note" className="truncate" title={d.time_note}>{d.time_note}</p>}
    </div>
  );
};
